import React, { Component } from "react";
import { app } from "../../index";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closemodal } from "../../actions/modal-handler";
import {
  Icon,
  Modal,
  Header,
  Button,
  List,
  Form,
  Input,
  TextArea,
  Grid,
  Dropdown,
  Label,
  Image,
  Segment
} from "semantic-ui-react";
import "./ass.css";
import moment from "moment";
class Assignments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assigned: null,
      unassignedemps: [],
      assignemps: [],
      wod: null,
      assemp: null,
      assigning: 0,
      markuppercent: null,
      salarycodes: null,
      newassignment: {
        empnumber: null,
        assigned_task: props.wod.workOrderNbr,
        comment: "",
        removed: 0,
        starttask: null,
        finishtask: null,
        readdocs: "1",
        codenumber: null,
        assignedrate: null
      }
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.wod !== this.props.wod &&
      this.props.employees.length &&
      this.props.assign
    ) {
      console.log("populating emps");
      if (!this.state.salarycodes) {
        this.gensalaryoptions();
      }
    }
  }
  gemplist(assignments) {
    let emps = this.props.employees.map((emp, index) => {
      return {
        ind: index,
        key: emp.empnumber,
        value: emp,
        text: emp.firstname + " " + emp.lastname
      };
    });
    if (assignments && assignments.length) {
      assignments.map(assign => {
        let empindex = emps.findIndex(
          emp => parseInt(emp.key) === assign.empnumber
        );
        emps.splice(empindex, 1);
      });
    }
    if (this.state.unassignedemps.length !== emps.length) {
      this.setState({
        unassignedemps: emps
      });
    }
  }
  handleAssign(assignments) {
    this.props
      .handleNewAssignment(this.state.newassignment)
      .then(response => {
        // var newemp = Object.assign({}, this.state.newassignment);
        // newemp.employee = this.props.employees.find(
        //   e => e.empnumber === this.state.newassignment.empnumber
        // );
        this.props.refreshWod();
        this.setState({
          assigning: false
        });
      })
      .catch(err => console.log(err));
  }
  genasslist(assignments) {
    if (assignments && assignments.length) {
      this.gemplist(assignments);
      var templist = Array.from(assignments);
      return templist.map((ass, index) => {
        let empinfo = ass.employee;
        return (
          <List.Item>
            <List.Content id="asslist" floated="right">
              <Button
                icon
                size="mini"
                onClick={() => {
                  let clone = Object.assign({}, ass);
                  delete clone.employee
                  this.setState({
                    assigning: false,
                    editing: false
                  })
                  setTimeout(() => {
                    this.setState({ assigning: true, editing: true, tmpAss: clone, assemp: ass.employee })
                  }, 100);

                }}
              >
                <Icon name="edit" />
              </Button>
            </List.Content>
            <List.Content>
              {" $" +
                ass.assignedrate +
                "    " +
                empinfo.firstname +
                " " +
                empinfo.lastname}
            </List.Content>
          </List.Item>
        );
      });
    } else {
      this.gemplist();
      return <List.Item> No one assigned. </List.Item>;
    }
  }
  genAssHeader(assignments) {
    if (assignments && assignments.length) {
      return (
        <List.Item>
          <h4> Assigned Employees </h4>
        </List.Item>
      );
    }
  }
  gensalaryoptions() {
    if (this.props.wod) {
      app
        .service("salarycodes")
        .find()
        .then(results => {
          if (results.data) {
            results = results.data;
          }
          let resultoptions = results.map(result => {
            return {
              key: result.code,
              value: result,
              text:
                result.location +
                " - " +
                result.description +
                " - $" +
                result.payrate
            };
          });
          console.log(resultoptions);
          this.setState({
            salarycodes: resultoptions
          });
        });
    }
  }
  assignform(assignments) {

    if (this.state.assigning) {
      var stateKey = this.state.editing ? "tmpAss" : "newassignment";
      var tempass = this.state[stateKey];
      console.log("TempAss", tempass);
      return (
        <Form>
          <Form.Group widths="equal">
            <Form.Field
              control={Input}
              label="Name"
              value={
                this.state.assemp.firstname + " " + this.state.assemp.lastname
              }
            />
            <Form.Field>
              <Label> Salary Code </Label>
              <Dropdown
                selection
                search
                fluid
                value={tempass.codenumber}
                options={this.state.salarycodes.map(sc => ({ ...sc, value: sc.key }))}
                onChange={(e, { value }) => {
                  value = this.state.salarycodes.find(sc => sc.key === value).value;
                  tempass.codenumber = value.code;
                  tempass.assignedrate = value.payrate;
                  this.setState({
                    [stateKey]: tempass
                  });
                }}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <Label> Start Date </Label>
              <Input
                type="date"
                value={tempass.starttask}
                onChange={e => {
                  tempass.starttask = moment(e.target.value).format(
                    "YYYY-MM-DD"
                  );
                  this.setState({
                    [stateKey]: tempass
                  });
                }}
              />
            </Form.Field>
            <Form.Field>
              <Label> End Date </Label>
              <Input
                type="date"
                value={tempass.finishtask}
                onChange={e => {
                  tempass.finishtask = moment(e.target.value).format(
                    "YYYY-MM-DD"
                  );
                  this.setState({
                    [stateKey]: tempass
                  });
                }}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group widths="equal">
            <Form.Field>
              <Label> Comments </Label>

              <TextArea
                value={tempass.comment}
                onChange={e => {
                  tempass.comment = e.target.value;
                  this.setState({
                    [stateKey]: tempass
                  });
                }}
              />
            </Form.Field>
          </Form.Group>
          {this.state.editing ? (
            <div>
              <Button
                color="green"
                disabled={
                  !tempass.codenumber || !tempass.finishtask || !tempass.starttask
                }
                onClick={() => app
                  .service("assign")
                  .update(tempass.id, tempass)
                  .then(response => {
                    this.props.refreshWod();
                  })}
                inverted
              >
                <Icon name="checkmark" /> Update Assignment
              </Button>
              <Button
                color="red"
                disabled={
                  !tempass.codenumber || !tempass.finishtask || !tempass.starttask
                }
                onClick={() => app
                  .service("assign")
                  .patch(tempass.id, {
                    removeddate: moment().format("YYYY-MM-DD"),
                    removed: true
                  })
                  .then(response => {
                    this.setState({ assigning: false, editing: false })
                    this.props.refreshWod();
                  })}
                inverted
              >
                <Icon name="delete" /> Delete Assignment
              </Button>
            </div>

          ) : (
            <Button
              color="green"
              disabled={
                !tempass.codenumber || !tempass.finishtask || !tempass.starttask
              }
              onClick={() => this.handleAssign(assignments)}
              inverted
            >
              <Icon name="checkmark" /> Add {this.state.assemp.firstname}
            </Button>
          )
          }

        </Form >
      );
    }
  }
  render() {
    var assignments = Array.from(
      this.state.assigned ? this.state.assigned : this.props.wod.assigned
    );
    return (
      <div className="Assignments">
        <Modal
          open={this.props.showModal}
          onClose={() => {
            this.props.closemodal();
          }}
          closeOnEscape={true}
          closeOnRootNodeClick={true}
          size="large"
        >
          <Header as="h2">
            <Image
              src={require("./edf_logo.bmp")}
              size="large"
              id="loginheader"
            />
            {this.props.wod.workOrderNbr + " "}
            Assigned Employees
          </Header>
          <Modal.Content>
            <Grid>
              <Grid.Row centered>
                <Grid.Column width={6}>
                  <Dropdown
                    className="icon"
                    floating
                    button
                    fluid
                    labeled
                    icon="add user"
                    options={this.state.unassignedemps}
                    search
                    onChange={(e, { value }) => {
                      this.setState({
                        assigning: false,
                        editing: false
                      })
                      setTimeout(() => {
                        this.setState({
                          assigning: true,
                          assemp: value,
                          newassignment: {
                            ...this.state.newassignment,
                            empnumber: parseInt(value.empnumber)
                          }
                        });
                      }, 100);


                      this.forceUpdate()
                    }}

                    text="Assign Employee"
                  />
                  <Segment>
                    <List>
                      {this.genAssHeader(assignments)}
                      {this.genasslist(assignments)}
                    </List>
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {this.assignform(assignments)}
          </Modal.Content>
          <Modal.Actions />
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    assign: state.jobs.assignedjobs,
    showModal: state.modal === "assigned",
    employees: state.employees.employees
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closemodal: closemodal
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(Assignments);


// WEBPACK FOOTER //
// ./src/components/shared-components/assignmentmanager.js